/* ============
 * Locale
 * ============
 *
 * For a multilanguage application, you can
 * specify the languages you want to use here.
 */

import en from './en';
import th from './th';

export default {
  en,
  th,
};



// WEBPACK FOOTER //
// ./src/locale/index.js